<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="奖励名称">
                  <el-input style="width: 186px;" v-model="queryForm.rewardName"></el-input>
              </el-form-item>
              <el-form-item label="安置类型">
                  <!-- <el-input  v-model="queryForm.placeId"></el-input> -->
                  <el-select
                    size="small"
                    style="width: 186px;"
                    v-model="queryForm.placeId"
                  >
                    <el-option
                      v-for="item in placeIdList"
                      :key="item.id"
                      :label="item.placeName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="奖励类型">
                  <!-- <el-input  v-model="queryForm.rewardType"></el-input> -->
                  <el-select
                    size="small"
                    style="width: 186px"
                    v-model="queryForm.rewardType"
                    :disabled="queryForm.placeId == ''"
                  >
                    <el-option
                      v-for="item in newEumns"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否激活">
                  <!-- <el-input  v-model="queryForm.isActive"></el-input> -->
                  <el-select
                      style="width: 186px;"
                      v-model="queryForm.isActive"
                      size="small"
                      placeholder="请选择"
                  >
                      <el-option
                          label="是"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="否"
                          :value="0"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="奖励介绍">
                  <el-input style="width: 186px;" v-model="queryForm.rewardIntro"></el-input>
              </el-form-item>
              <el-form-item label="字典类型">
                  <el-input style="width: 186px;" v-model="queryForm.dictType"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelRewardList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelReward"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editModelReward(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelReward(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshModelRewardList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelRewardList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rewardName"
        label="奖励名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rewardType"
        label="奖励类型"
        min-width="180"
      > 
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="placeId"
        label="安置类型"
        min-width="180"
      >
        <template slot-scope="scop">
          {{ returnPlaceIdList(scop.row.placeId) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isActive"
        label="是否激活"
        min-width="180"
      > 
        <template slot-scope="scop">
          {{ scop.row.isActive == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="rewardIntro"
        label="奖励介绍"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dictType"
        label="字典类型"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <MgJzD :typeId="scop.row.dictType" style="margin-left: 3px;"></MgJzD>
            <div @click="checkModelReward(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editModelReward(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteModelReward(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelRewardStates[modelRewardState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelReward"
          ref="modelRewardForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <!-- <el-form-item
            label="奖励名称"
            prop="rewardName"
          >
            <el-input
              size="small"
              style="width: 186px;"
              v-model="modelReward.rewardName"
              :disabled="modelRewardState == 'check'"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="安置类型"
            prop="placeId"
          >
            <!-- <el-input
              size="small"
              v-model="modelReward.placeId"
              :disabled="modelRewardState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px;"
              v-model="modelReward.placeId"
              :disabled="modelRewardState == 'check'"
            >
              <el-option
                v-for="item in placeIdList"
                :key="item.id"
                :label="item.placeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="奖励名称"
            prop="rewardType"
          >
            <!-- <el-input
              size="small"
              v-model="modelReward.rewardType"
              :disabled="modelRewardState == 'check' || modelReward.placeId == ''"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="modelReward.rewardType"
              :disabled="modelRewardState == 'check' || modelReward.placeId == ''"
            >
              <el-option
                v-for="item in newEumn"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否激活"
            prop="isActive"
          >
            <!-- <el-input
              size="small"
              v-model="modelReward.isActive"
              :disabled="modelRewardState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 186px;"
                v-model="modelReward.isActive"
                size="small"
                placeholder="请选择"
                :disabled="modelRewardState == 'check'"
            >
                <el-option
                    label="是"
                    :value="1"
                ></el-option>
                <el-option
                    label="否"
                    :value="0"
                ></el-option>
            </el-select>
          </el-form-item>
         
          <el-form-item
            label="奖励介绍"
            prop="rewardIntro"
          >
            <el-input
              size="small"
              style="width: 186px;"
              v-model="modelReward.rewardIntro"
              :disabled="modelRewardState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="字典类型"
            prop="dictType"
          >
            <el-input
              size="small"
              style="width: 186px;"
              v-model="modelReward.dictType"
              :disabled="modelRewardState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelRewardState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlace.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
    computed:{
      newEumn(){
        return this[`auditStatus${this.emap}`];
      },
      newEumns(){
        return this[`auditStatus${this.emaps}`];
      }
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelRewardList();
                    this.getModelRewardList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelRewardList();
                    this.getModelRewardList();
                    this.$emit('resetCheckState');
                }
            },
            'modelReward.placeId':{
                handler(val,old) {
                    if (val == old || val == null || val == '' || val == undefined) {
                        return;
                    }
                    for (const iterator of this.placeIdList) {
                      if(iterator.id == val){
                        this.emap = iterator.placeType;
                      }
                    }
                    // 一会儿return
                },
            },
            'queryForm.placeId':{
                handler(val,old) {
                    if (val == old || val == null || val == '' || val == undefined) {
                        return;
                    }
                    for (const iterator of this.placeIdList) {
                      if(iterator.id == val){
                        this.emaps = iterator.placeType;
                      }
                    }
                    // 一会儿return
                },
            }
        },
    data() {
            return {
                emaps: "",
                queryForm:{
                     rewardName: '', //奖励名称
                     rewardType: '', //奖励类型
                     placeId: '', //安置ID
                     isActive: '', //是否激活
                     rewardIntro: '', //奖励介绍
                     dictType: '', //字典类型
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelRewardState: 'add',
                modelRewardStates: {
                    add: '新建奖励',
                    check: '查看奖励',
                    edit: '修改奖励'
                },
                emap: '',
                multipleSelection: [],
                modelRewardList: [],
                modelReward: {
                    id: '', //ID
                    rewardName: '', //奖励名称
                    rewardType: '', //奖励类型
                    placeId: '', //安置ID
                    isActive: '', //是否激活
                    rewardIntro: '', //奖励介绍
                    dictType: '', //字典类型
                    createTime: '', //
                    obtainCondition: ''
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    rewardName: [{ required: true, message: '奖励名称不能为空', trigger: 'blur' }],
                    rewardType: [{ required: true, message: '奖励类型不能为空', trigger: 'blur' }],
                    placeId: [{ required: true, message: '安置ID不能为空', trigger: 'blur' }],
                    isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                    rewardIntro: [{ required: true, message: '奖励介绍不能为空', trigger: 'blur' }],
                    // dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    obtainCondition: [{ required: true, message: '获取条件不能为空', trigger: 'blur' }],
                },
                placeIdList:[],
                auditStatus1:[],
                auditStatus2:[],
                auditStatus3:[],
                auditStatus4:[],
                auditStatus5:[],
                auditStatus6:[],
                auditStatus7:[],
                auditStatus8:[],
            };
        },
        created() {
            this.getplaceIdList();
            this.getEnums();
        },
        mounted() {
            this.getModelRewardList();
        },
        methods: {
            getplaceIdList(){
                get('/model/place/findAll').then(res => {
                    this.placeIdList = res.list;
                });
            },
            returnPlaceIdList(key){
                for (const iterator of this.placeIdList) {
                  if(key == iterator.id){
                    return iterator.placeName;
                  }
                }
            },
            getEnums(){
              for(let i = 1;i<=7;i++){
                get('/mpp/utils/getEnum', { enumType: `model_place${i}_reward_type` }).then((res) => {
                  this[`auditStatus${i}`] = res.enumList;
                });
              }
              get('/mpp/utils/getEnum', { enumType: `model_recommend_reward_type` }).then((res) => {
                  this.auditStatus8 = res.enumList;
                });
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetModelRewardList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelRewardList = [];
            },
            resetDialog() {
                this.modelRewardState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      rewardName: '', //奖励名称
                      rewardType: '', //奖励类型
                      placeId: '', //安置ID
                      isActive: '', //是否激活
                      rewardIntro: '', //奖励介绍
                      dictType: '', //字典类型
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                };
                this.getModelRewardList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelReward = {
                      id: '', //ID
                      rewardName: '', //奖励名称
                      rewardType: '', //奖励类型
                      placeId: '', //安置ID
                      isActive: '', //是否激活
                      rewardIntro: '', //奖励介绍
                      dictType: '', //字典类型
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                      obtainCondition: ''
                };
            },
            submitForm() {
                if (this.modelRewardState == 'add') {
                    this.$refs.modelRewardForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/rewardplace/add`,{ ...this.modelReward }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelRewardList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelRewardState == 'edit') {
                    this.$refs.modelRewardForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/rewardplace/edit`,{ ...this.modelReward }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelRewardList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelReward() {
                this.showDialog = true;
                this.modelRewardState = 'add';
            },
            checkModelReward(modelRewardId) {
                console.log(modelRewardId);
                this.currentModelRewardId = modelRewardId;

                this.getModelRewardById();
                this.showDialog = true;
                this.modelRewardState = 'check';
            },
            editModelReward(modelRewardId) {
                console.log('modelReward', modelRewardId);
                if (modelRewardId) {
                    this.currentModelRewardId = modelRewardId;
                    this.getModelRewardById();
                } else {
                    this.modelReward = { ...this.modelReward, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelRewardState = 'edit';
            },
            deleteModelReward(modelRewardId) {
                let ids = '';
                if (modelRewardId) {
                    ids = modelRewardId;
                } else {
                    ids = this.multipleSelection.map((modelReward) => modelReward.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/rewardplace/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelRewardList();
                                this.getModelRewardList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelRewardList() {
                this.resetModelRewardList();
                this.getModelRewardList();
            },
            getModelRewardList(query = {}) {
                this.loading = true;
                get(`/model/rewardplace/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelRewardList = res.page.list;
                        console.log(this.modelRewardList)
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelRewardById() {
                get(`/model/rewardplace/get`,{ id: this.currentModelRewardId }).then((res) =>{
                    if(res.success){
                      this.modelReward = { ...this.modelReward, ...res.modelReward };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelRewardList() {
                //this.btnLoading = true;
                exprotExcel(`/model/rewardplace/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/rewardplace/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/rewardplace/importData`,formData);
              this.refreshModelRewardList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelRewardList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelRewardList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>